
import wx from 'weixin-js-sdk'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'


export default {
name: 'addProduct',
components: {
wx,PopupPicker,CheckIcon,XTextarea,Group
},
data() {
return {
pop:false,
filePath: [],
formData:{
id:0,
title:'',
pics:[],
cate_id:0,
attr:'',
price:'',

content:''
},
category:[],
cateName:'请选择分类',
pickerStatus:false,

product:[],
productList:[],
}
},
created() {
this.getCategory();
this.getProduct();
this.formData.id = Number(this.$route.params.id);
if(this.formData.id > 0){
this.productDetial();
}

},
computed:{

},
methods: {
handleInput(){

const reg = new RegExp(this.formData.title,'g');
const replaceString = '<span class="cm-color-red">'+this.formData.title+'</span>';
this.productList = this.product.filter((item) => {
if(item.title.indexOf(this.formData.title) > -1){
return item.title.replace(this.formData.title,replaceString);
}
})


this.pop = this.productList.length > 0 ? true : false;
},
selectProduct(item){
this.formData.pid = item.id;
this.formData.title = item.title;
this.formData.cate_id = item.cate_id;
this.cateName = item.category.name;
this.filePath = item.pics_path;
this.formData.pics = item.pics;
this.pop = false;
},
productDetial() {

this.$api.productDetial({id:this.formData.id}).then((res)=>{
if(res){
this.formData = res.data;
this.cateName = res.data.category.name;
this.filePath = res.data.pics_path;
}
})

},
getProduct() {

this.$api.searchProduct({title:this.formData.title}).then((res)=>{
if(res){
this.product = res.data;
}
})

},
getCategory() {
this.$api.category({}).then((res)=>{
if(res){
this.category = res.data;
}
})
},










cate(value){
this.formData.cate_id = value;
},
submit() {
console.log(this.formData);
if(!this.formData.title){
this.$func.showToast('请输入商品名称');
return false;
}
if(!this.formData.cate_id){
this.$func.showToast('请选择分类');
return false;
}
if(!this.formData.attr){
this.$func.showToast('请输入商品规格');
return false;
}
if(!this.formData.price){
this.$func.showToast('请输入商品价格');
return false;
}
if(!this.formData.pics.length){
this.$func.showToast('请输入上传照片');
return false;
}




this.$api.submitProduct(this.formData).then((res)=>{
this.$func.showToast('提交成功');
setTimeout(()=>{
this.$router.go(-1);
},300)
});
},
config(){








let url = (window.location.href).split('#');
if(url[0].indexOf('?') != '-1'){
url = url[0].split('?');
}
this.$api.wxSign({url:url[0]}).then((res)=>{
if(res){
wx.config({
debug: false, //调试阶段建议开启
appId: res.data.appId,
timestamp: res.data.timestamp,
nonceStr: res.data.nonceStr,
signature:res.data.signature,
jsApiList: [
"chooseImage",
"uploadImage",
]
});
}
})
},
uploadFile(){
let that = this;
wx.chooseImage({
count: 9,
sizeType: ['original', 'compressed'],
sourceType: ['album', 'camera'],
success: function (res) {
that.uploadImg(res.localIds);
}
});
},
uploadImg(localIds){
let localId = localIds.pop();
let that = this;
wx.uploadImage({
localId: localId,
success: function (res) {
that.$api.uploadsImg({serverId:res.serverId,path:'product'}).then((res)=>{
if(res){
that.filePath.push(res.data.url);
that.formData.pics.push(res.data.path);
if(localIds.length > 0){
that.uploadImg(localIds);
}
}
})
}
});
},
showPic(index) {
wx.previewImage({
current: this.filePath[index], // 当前显示图片的http链接
urls: this.filePath 
});
},
delImg(index){
this.filePath.splice(index,1);
this.formData.pics.splice(index,1);
}
}
}



// WEBPACK FOOTER //
// ./src/pages/addProduct.vue